if (!window.__songmontCountrySyncLoaded) {
  window.__songmontCountrySyncLoaded = true;

  document.addEventListener('DOMContentLoaded', function () {
    const countryForm = document.getElementById('LocalizationModal--country-form');
    if (!countryForm) return;

    const countrySelect = countryForm.querySelector('select[name="country_code"]');
    if (!countrySelect) return;

    const STORAGE_KEY = 'songmont_pending_country';
    const url = new URL(window.location.href);

    const targetCountry = url.searchParams.get('country');
    const currentCountry = countrySelect.value;

    // 用户直接访问带 ?country=XX 的链接时，同步 Shopify localization
    if (targetCountry && targetCountry !== currentCountry) {
      sessionStorage.setItem(STORAGE_KEY, targetCountry);
      countrySelect.value = targetCountry;
      countryForm.submit();
      return;
    }

    // localization 提交回来后，把参数补回 URL
    const pendingCountry = sessionStorage.getItem(STORAGE_KEY);
    if (pendingCountry && pendingCountry === currentCountry) {
      url.searchParams.set('country', currentCountry);
      history.replaceState({}, '', url.toString());
      sessionStorage.removeItem(STORAGE_KEY);
    }

    // 用户手动切国家时，先记住目标国家
    countryForm.addEventListener('submit', function () {
      sessionStorage.setItem(STORAGE_KEY, countrySelect.value);
    });
  });
}